module.exports = __webpack_public_path__ + "resources/img/certi_isms_p.0ec19967ed97c461976180524d8bc1a1.png";